__turbopack_context__.v({
  "maskedField": "AutoNumberInput-module__Pag1wa__maskedField",
  "maskedFilled": "AutoNumberInput-module__Pag1wa__maskedFilled",
  "maskedInput": "AutoNumberInput-module__Pag1wa__maskedInput",
  "maskedOverlay": "AutoNumberInput-module__Pag1wa__maskedOverlay",
  "maskedPlaceholder": "AutoNumberInput-module__Pag1wa__maskedPlaceholder",
  "placeholder": "AutoNumberInput-module__Pag1wa__placeholder",
  "regionChars": "AutoNumberInput-module__Pag1wa__regionChars",
});
